import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_CONTACT_WHITELIST_UPDATE_RESOURCE = "casavi-contact-whitelist" as const;
export const CASAVI_CONTACT_WHITELIST_UPDATE_API_PATH =
  `/v1/${CASAVI_CONTACT_WHITELIST_UPDATE_RESOURCE}/{uuid}` as const;

export type CasaviContactWhitelistUpdateBody =
  paths[typeof CASAVI_CONTACT_WHITELIST_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type CasaviContactWhitelistUpdateResponse =
  paths[typeof CASAVI_CONTACT_WHITELIST_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useCasaviContactWhitelistUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviContactWhitelistUpdateResponse, Error, CasaviContactWhitelistUpdateBody & { uuid: string }>({
    mutationFn: async (casaviContactWhitelist: CasaviContactWhitelistUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = casaviContactWhitelist;
      const response = await alphartisApiAxios.patch<CasaviContactWhitelistUpdateResponse>(
        `/v1/${CASAVI_CONTACT_WHITELIST_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_CONTACT_WHITELIST_UPDATE_RESOURCE],
      });
    },
  });
};
